var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOrganisationForm)?_c('organisation-registration-form',{staticClass:"registration-form"}):_c('registration-form',{staticClass:"registration-form"})}
var staticRenderFns = []

export { render, staticRenderFns }